module.exports = __webpack_public_path__ + "static/img/5555.dc9c5fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/5555.jpg
// module id = lEJ7
// module chunks = 1